export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6794.0a914ec3.jpg";